
import { runsheetsSelectors } from '@/entities/schedules'
import { fetchHistoricalRunsheets } from '@/entities/schedules/thunks/fetchHistoricalRunsheets'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { UserInterfaceState } from '../model/UserInterfaceState'
import { setGlobalLoading, setSelectedSearchResult } from '../slices/userInterfaceSlice'

/**
 * When the user select the search results, the following thunk will fetch the necessary information from the server.
 */
export const setOrderSearchResult = createAsyncThunk<void, UserInterfaceState['selectedSearchResult'], ThunkApiContext>(
  'userInterface/setOrderSearchResult',
  async (payload, { dispatch, getState }) => {
    const state = getState()

    if (!payload) return

    if (!payload.isPlanning && payload.scheduleId && payload.scheduleName) {
      dispatch(setGlobalLoading(true))

      // Check if we need to fetch historical runsheet
      const schedule = runsheetsSelectors.selectById(state, payload.scheduleId)

      if (!schedule) {
        await dispatch(fetchHistoricalRunsheets({
          date: payload.scheduleName,
          dateRangeOption: 1,
        }))
      }
    }

    dispatch(setGlobalLoading(false))
    dispatch(setSelectedSearchResult(payload))
  },
)
